import { X } from 'lucide-react';
import styled from 'styled-components';

import { Button } from '../../../../components/atoms/button/button';
import { Modal } from '../../../../components/molecules/modal/modal';
import { UsuarioInterno } from '../../../../types/usuario';

interface Props {
  isOpen: boolean;
  user: UsuarioInterno | null;
  loading?: boolean;
  errorMessage?: string | null;
  onConfirm: () => Promise<unknown> | void;
  onClose: () => void;
}

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Warning = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 13.5px;
`;

const ErrorAlert = styled.div`
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.dangerBg};
  border-left: 3px solid ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.danger};
  font-size: 13px;
`;

export const DeactivateUserModal = ({
  isOpen,
  user,
  loading,
  errorMessage,
  onConfirm,
  onClose,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={() => (!loading ? onClose() : undefined)}
    title="Desativar usuário"
    description={user ? `Tem certeza que deseja desativar ${user.name}?` : undefined}
    size="sm"
    footer={
      <>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={() => onConfirm()}
          loading={loading}
          startIcon={!loading ? <X size={14} /> : undefined}
          data-testid="deactivate-action"
        >
          {loading ? 'Desativando…' : 'Desativar'}
        </Button>
      </>
    }
  >
    {user && (
      <Body>
        <p>Ao desativar este usuário:</p>
        <Warning>
          <li>Ele perderá acesso ao backoffice imediatamente.</li>
          <li>Tokens antigos deixarão de funcionar na próxima requisição.</li>
          <li>A operação pode impactar funções internas em andamento.</li>
        </Warning>
        {errorMessage && <ErrorAlert role="alert">{errorMessage}</ErrorAlert>}
      </Body>
    )}
  </Modal>
);
